// Function to search for a specific value and return its path
export function findPath(obj, targetValue, currentPath = '') {
if (typeof obj === 'object') {
    for (let key in obj) {
        const path = currentPath === '' ? key : `${currentPath}.${key}`;
        const foundPath = findPath(obj[key], targetValue, path);
        if (foundPath) {
            return foundPath;
        }
    }
} else {
    if (obj === targetValue) {
    return currentPath;
    }
}
return undefined; // Value not found
}

export function deletePropertyPath (obj, path) {

    if (!obj || !path) {
    return;
    }

    if (typeof path === 'string') {
    path = path.split('.');
    }

    for (var i = 0; i < path.length - 1; i++) {

    obj = obj[path[i]];

    if (typeof obj === 'undefined') {
        return;
    }
    }

    delete obj[path.pop()];
}

export function existingComplexFilters(complexFiltersToCheck, availableFeatures, existingFilters) {
    if (!complexFiltersToCheck) return;
      Object.keys(complexFiltersToCheck).forEach((key) => { 
        // rule is the only field that holds the individual filter
        if (complexFiltersToCheck[key] && complexFiltersToCheck[key].type === "rule" && complexFiltersToCheck[key].properties.field) {
          // split the data series from the id as stored in complex filters. 
          const field = complexFiltersToCheck[key].properties.field.split('__'); 
          const field_ds = field[0];
          const field_id = field[1];
          // use the helper function to check if it has a path in available filters. 
          let path = findPath(availableFeatures, field_id);
          // if not found, delete from the complex filters
          if (!path) { 
            // find the path of the id in the complex filter
            let deadFeature = findPath(existingFilters, field_ds + "__" + field_id);
            if (deadFeature && deadFeature.includes('.')) {
              deadFeature = deadFeature.split('.');
              // remove the last to properties
              deadFeature.splice(deadFeature.length - 2, deadFeature.length);
              // join back into a path string
              deadFeature = deadFeature.join('.');
            }
            if (deadFeature) {
              // use a helper function to remove using the path
              deletePropertyPath(existingFilters, deadFeature);
            }
          }
          // if group type, run this function again with that part of the object on it's children
            } else if (complexFiltersToCheck[key]) {
            existingComplexFilters(complexFiltersToCheck[key].children1, availableFeatures, existingFilters);
            }
      });
  return existingFilters;
}
    
export function existingSimpleFilters(filtersToCheck, availableFeatures, existingSimpleFilters) {
  if (!filtersToCheck) return;
  // Some filters come in as an object. Some as an array. Check which type and covert to an array for checking. 
    const simpleFilters = (
      typeof filtersToCheck === 'object' &&
      Array.isArray(filtersToCheck)
    ) ?
      filtersToCheck :
      Object.entries(filtersToCheck);
  
  existingSimpleFilters = simpleFilters.filter((f) => (availableFeatures || []).find((c) => {
    return (f[0] === "undefined") || (c && f[0] === c[0]);
  }));
  return existingSimpleFilters;
}

export function getDistinctAttributeValues(data, attribute_name) {
    const results = new Set();

    function traverse(value) {
        if (Array.isArray(value)) {
            for (const item of value) traverse(item);
        } else if (value !== null && typeof value === "object") {
            for (const [key, val] of Object.entries(value)) {
                if (key === attribute_name) results.add(val);
                traverse(val);
            }
        }
    }

    traverse(data);
    return [...results];
}

export function isEmpty(obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export function findDatasetsToDrop(config, dsAll, given) {
    if(isEmpty(config)) {return}
    const givenSet = new Set(given);
    const dsAllSet = new Set(dsAll);
    const toDrop = new Set();

    for (const rule of config.exclusives) {
        const suppressList = rule.suppress_exclusive_only || [];
        const unlessList = rule.unless || [];

        // Is any "unless" dataset referenced in the given list?
        const unlessReferenced = unlessList.some(u => givenSet.has(u));

        for (const ds of suppressList) {
            // Only care if it's actually available
            if (!dsAllSet.has(ds)) continue;

            // Never drop if the dataset itself is explicitly referenced
            if (givenSet.has(ds)) continue;

            // If any "unless" is referenced, keep all datasets in this rule
            if (unlessReferenced) continue;

            // Otherwise, this exclusive dataset is unreferenced and should be dropped
            toDrop.add(ds);
        }
    }

    return Array.from(toDrop);
}

export function getAllowedDatasets(filters, dsAll, _suppressed) {
    let referencedDatasets = getDistinctAttributeValues(filters, "ds");
    const toDrop = new Set(findDatasetsToDrop(_suppressed, dsAll, referencedDatasets));
    return dsAll.filter(ds => !toDrop.has(ds));
}

